import type { FC } from 'react'

const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ')

export type CoinIconVariant = 'arcs' | 'arcs-ethereum'

export interface CoinIconProps {
  variant?: CoinIconVariant
  className?: string
  'aria-label'?: string
}

const ICON_SOURCES: Record<CoinIconVariant, string> = {
  arcs: '/icons/ARCSCoinIcon.png',
  'arcs-ethereum': '/icons/ARCSEthereumCoinIcon.png',
}

const baseClasses = 'inline-flex size-10 items-center justify-center'

export const CoinIcon: FC<CoinIconProps> = ({
  variant = 'arcs',
  className,
  'aria-label': ariaLabel,
}) => {
  const src = ICON_SOURCES[variant]
  const isDecorative = !ariaLabel

  return (
    <span className={cx(baseClasses, className)}>
      <img
        src={src}
        alt={ariaLabel ?? ''}
        aria-hidden={isDecorative || undefined}
        className="block size-full"
      />
    </span>
  )
}

export interface CoinIconShowcaseProps {
  className?: string
}

export const CoinIconShowcase: FC<CoinIconShowcaseProps> = ({ className }) => {
  return (
    <div
      className={cx(
        'inline-flex flex-col items-center gap-5 rounded-[28px] bg-white/70 px-5 py-6',
        className
      )}
    >
      <CoinIcon variant="arcs" />
      <CoinIcon variant="arcs-ethereum" />
    </div>
  )
}

export default CoinIcon
